const videoMain = {
  liveVideo: {
    noTitleType: true,
    title: "视频直播",
    image: "./images/video.png",
    tips:
      "为银行及中小企业打造自己的私域视频直播平台，专注服务私域流量用户，实现转化率与营收的提升。客户经理变身“主播”，通过视频直播宣导通识课、普及理财知识，直播“带货”，一步触达客户。",
    features: "功能特点",
    featuresEn: "FEATURES",
    list: [
      {
        title: "便捷高效",
        icon: "./images/video1.png",
        tips: "可指定观众连麦，直接与客服沟通便捷高效"
      },
      {
        title: "灵活设置",
        icon: "./images/video2.png",
        tips: "可灵活设置直播带货产品（金融产品与电商商品）"
      },
      {
        title: "SDK集成",
        icon: "./images/video3.png",
        tips: "最快两周投入生产环境"
      },
      {
        title: "安全私域",
        icon: "./images/video4.png",
        tips: "私有化部署，安全，高效私域 "
      }
    ]
  },
  videoTeller: {
    noTitleType: true,
    title: "视频柜员",
    image: "./images/videoTeller1.png",
    tips:
      "打破传统物理网点对银行服务延伸的束缚，可随时随地与银行柜员联动，视频语音就可办理业务，客户体验更佳（如“银发”客户手机操作不熟练，更适合视频柜员场景）。 全业务线上办理，视频柜员多方互动一键搞定。",
    features: "功能特点",
    featuresEn: "FEATURES",
    list: [
      {
        title: "快上线",
        icon: "./images/videoTeller2.png",
        tips: "最快两周投产，实现视频客服能力"
      },
      {
        title: "全业务",
        icon: "./images/videoTeller3.png",
        tips: "在视频柜员中实现银行全业务办理能力"
      },
      {
        title: "无接触",
        icon: "./images/videoTeller4.png",
        tips: "线上完成在网点柜员"
      },
      {
        title: "柜员转型",
        icon: "./images/videoTeller5.png",
        tips: "网点柜员变身为兼职柜员，优先为本网点的客户提供金融服务 "
      }
    ]
  },
  videoFaceToFace: {
    noTitleType: true,
    title: "视频面签",
    image: "./images/videoFaceToFace1.png",
    tips:
      "徕檬推出的远程签约系统，实现零摩擦业务办理，支持合同视频快速签订，可极大提升客户经理工作效率与用户体验。",
    features: "功能特点",
    featuresEn: "FEATURES",
    list: [
      {
        title: "开箱即用",
        icon: "./images/videoFaceToFace2.png",
        tips: "用户注册审批后即可使用 "
      },
      {
        title: "全适用",
        icon: "./images/videoFaceToFace3.png",
        tips: "适用所有合同签约流程"
      },
      {
        title: "全流程",
        icon: "./images/videoFaceToFace4.png",
        tips: "从进件到审批到合同签约"
      },
      {
        title: "工具输出",
        icon: "./images/videoFaceToFace5.png",
        tips: "可以提供给第三方机构（担保公司）的客户经理使用，进件无忧、审批无忧、签约无忧"
      }
    ]
  },
  videoconferencing: {
    noTitleType: true,
    title: "视频会议",
    image: "./images/videoconferencing1.png",
    tips:
      "突破距离与空间限制，随时随地组织、发起远程视频会议。无接触办公、私有化部署，会议内容（视频、音频）安全、保密。",
    features: "功能特点",
    featuresEn: "FEATURES",
    list: [
      {
        title: "安全成熟",
        icon: "./images/videoconferencing2.png",
        tips: "安全、成熟，支持快速部署 "
      },
      {
        title: "适应多种场景",
        icon: "./images/videoconferencing3.png",
        tips: "会议音频实时转换文字适应多种会议场景"
      },
      {
        title: "提高会议效率",
        icon: "./images/videoconferencing4.png",
        tips: "自动生成发言记录、会议结论、会议追踪，提高会议效率"
      }
    ]
  },
  videoDiagnosis: {
    noTitleType: true,
    title: "视频诊疗",
    image: "./images/videoDiagnosis1.png",
    tips:
      "金融机构通过自身的资源整合，为高端客户提供名医诊疗增值服务。切合远程医疗、诊疗场景，为诊疗过程中的高清音、视频、低延迟沟通提供支持。 ",
    features: "功能特点",
    featuresEn: "FEATURES",
    list: [
      {
        title: "安全保密",
        icon: "./images/videoDiagnosis2.png",
        tips: "私有化部署，沟通内容安全保密"
      },
      {
        title: "提高诊断效率",
        icon: "./images/videoDiagnosis3.png",
        tips: "自动生成病例、诊疗结论、诊疗历史记录等，提升诊断效率降低误诊率"
      },
      {
        title: "专有词库",
        icon: "./images/videoDiagnosis4.png",
        tips: "专有医疗词库，语音识别更准确"
      }
    ]
  },
  videoLoss: {
    noTitleType: true,
    title: "视频定损",
    image: "./images/videoLoss1.png",
    tips:
      "适用于保险公司对车险现场进行远程定损。出险后无须定损员现场处理，只需批量上传涉险车辆、环境照片，即可完成在线报险，缩短了工单流程，节省保险公司人力成本的同时，极大提升了车险处理效率。",
    features: "功能特点",
    featuresEn: "FEATURES",
    list: [
      {
        title: "一键上传",
        icon: "./images/videoLoss2.png",
        tips: "一键上传涉险照片与环境照片即可完成定损，节约出险客服理赔时间"
      },
      {
        title: "提高车险理赔效率",
        icon: "./images/videoLoss3.png",
        tips: "报险完成后同步预估出险额度缩短定损时间，提升车险理赔处理时间"
      },
      {
        title: "加强定损管理",
        icon: "./images/videoLoss4.png",
        tips: "有助于加强定损管理，减少人情定损、骗保等行为"
      }
    ]
  },
  videoInterview: {
    noTitleType: true,
    title: "视频面试",
    image: "./images/videoInterview1.png",
    tips:
      "AI虚拟机器人自动化搜索人才简历，自动化初筛、初沟通，且实时记录候选人的情绪变化、肢体语言，回答质量等数据。综合分析，向HR团队实时反馈。",
    features: "功能特点",
    featuresEn: "FEATURES",
    list: [
      {
        title: "安全可控",
        icon: "./images/videoInterview2.png",
        tips: "私有化部署，面试过程全程记录数据安全可控"
      },
      {
        title: "提高选人效率",
        icon: "./images/videoInterview3.png",
        tips: "AI参与搜索人才，初步筛选人才效率大大提升"
      },
      {
        title: "算法实施精进",
        icon: "./images/videoInterview4.png",
        tips: "算法实时精进，系统越用越聪明"
      }
    ]
  }
};
export default videoMain;
